@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/links";
@use "../../../globals/bcp-2022/objects/lists";
@use "../../../globals/libs/hy.core.css/layout/page-row";
@use "../../../globals/bcptools/tools/css-variables" as cs;
@use "../../../globals/bcptools/tools/_frok.scss" as *;

tt-add-to-cart {
  height: 10px;
}

:host {
  max-width: 20rem;
}

.a-search-suggestions__item-actions {
  padding-left: bcp.n(1);
  grid-area: actions;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @include bcp.respond-lte(tabletp) {
    flex-direction: column;
  }

  .product-action {
    &__price-container {
      @include bcp.respond(tabletp) {
        display: none;
      }
    }

    &__quantity-updater-container {
      padding-right: bcp.n(1);

      @include bcp.respond-lte(tabletp) {
        padding-right: 0;
      }

      f-value-modificator {
        min-width: 10rem;
      }
    }

    &__action-buttons-container {
      @include bcp.respond-lte(tabletp) {
        padding: bcp.n(1) 0;
      }

      bcp-with-product-details .product-details {
        flex-direction: row;
        justify-content: start;
      }
    }
  }
}

//styles blocked by shadow dom added and adjusted
//from: node_modules/@bosch/frontend.kit-npm/src/frontend-kit/molecules/dialog/dialog.scss

.m-dialog {
  --max-dialog-width: 44rem;

  max-width: var(--max-dialog-width);
  z-index: 9999;

  .a-box {
    background-color: var(--background);
  }

  /* stylelint-disable declaration-colon-space-after */
  & > .a-box,
  & > .a-box--modal > .a-box {
    display: grid;
    grid-template-rows: repeat(3, auto) 1fr;
    grid-template-columns: minmax(auto, var(--max-dialog-width));
    grid-template-areas:
      "remark"
      "header"
      "divider"
      "content";
    max-height: calc(100vh - 4rem);
    overflow: hidden;
  }

  /* stylelint-enable declaration-colon-space-after */
  /* stylelint-disable */
  &__remark {
    grid-area: remark;
    height: rem(6px);

    &.--info {
      background-color: settings.$color-info;
    }

    &.--success {
      background-color: var(--major-signal-success__enabled__fill__default);
    }

    &.--warning {
      background-color: var(--major-signal-warning__enabled__fill__default);
    }

    &.--error {
      background-color: var(--major-signal-error__enabled__fill__default);
    }
  }
  /* stylelint-enable */

  &__header {
    grid-area: header;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 2rem;
    overflow: hidden;

    > .a-icon {
      margin-right: 0.5rem;
    }

    .a-button--integrated {
      margin-left: auto;
      margin-right: -2rem;
      display: flex;
    }
  }

  &__title {
    font-weight: 700;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @include bcp.theme("buderus") {
    @include bcp.set-css-var(link, color, settings.$brand-main);
    @include bcp.set-css-var(link-hover, color, settings.$blue30);
    @include bcp.set-css-var(link-active, color, settings.$blue20);

    &__title,
    &__headline {
      color: settings.$black;
    }
  }

  // reset margins of divider to achieve design specification
  .a-divider {
    grid-area: divider;
    margin: 0;
  }

  &__content {
    grid-area: content;
    overflow-y: auto;
    padding: 1.5rem 2rem 0;

    &:first-child {
      padding-top: 2rem;
    }

    > *:last-child {
      margin-bottom: 2rem;
    }
  }

  &__headline {
    margin-bottom: 1rem;

    font-size: rem(24px);
    line-height: 1.4;
    font-weight: 700;
  }

  &__code {
    margin-top: 1rem;

    font-size: rem(12px);
    line-height: 1.5;
  }

  &__actions {
    margin-top: 1.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 1rem;

    .a-button:nth-last-child(2) {
      margin-left: auto;
    }
  }
}
